import './PersonalInfo.css';
import React,{useState,useContext} from 'react';
import { uploadPersonalInfo } from '../helpers/firebase';
import FormState from '../context/FormState';
import LoadingScreen from './LoadingScreen';
import styles from "./personalInfo.module.css";
import logo from "../../../assets/img/logo.png";
import Profile_img from "../../../assets/img/Profile_img.png";
function PersonalInfo(props){
    const submithandler = async()=>{
        props.setStep("3");
    }
    const personalInfoForm=()=>{
        return(<div>
            {/* <Header></Header> */}
      
            <div className={styles.container}>
              <div className={styles.left}>
                <div className={styles.imageContainer}>
                  <img src={logo} alt="" />
      
                  <div className={styles.logoDesc}>
                    <p>VIT AP UNIVERSITY</p>
                    <p className={styles.smallDes}>Alumni Association</p>
                  </div>
                </div>
      
                {/* image kindha */}
                <div className={styles.sideNav}>
                  <div className={styles.navItem}>
                    <div className={styles.num}>1</div>
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Personal Information</p>
                      <p className={styles.psmallInfo}>Personal Profile Details</p>
                    </div>
                  </div>
      
                  <div className={styles.navItem} style={{"opacity":"0.6"}}>
                    <div className={styles.num}>2</div>
      
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Educational Information</p>
                      <p className={styles.psmallInfo}>Courses/degrees pursued</p>
                    </div>
                  </div>
      
                  <div className={styles.navItem} style={{"opacity":"0.6"}}>
                    <div className={styles.num}>3</div>
      
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Contact Details</p>
                      <p className={styles.psmallInfo}>Location and contact</p>
                    </div>
                  </div>
      
                  <div className={styles.navItem} style={{"opacity":"0.6"}}>
                    <div className={styles.num}>4</div>
      
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Work Details</p>
                      <p className={styles.psmallInfo}>Professional Details</p>
                    </div>
                  </div>
                </div>
              </div>
      
              <div className={styles.right}>
                <div className={styles.profile}>
                  <div className={styles.userInfo}>
                    <p className={styles.username}>Mervin Joseph</p>
                    <p>VIT AP University</p>
                  </div>
                  <img
                    src={Profile_img}
                    alt="Profile Image"
                    className={styles.profileImage}
                  />
                </div>
      
                <h1>Personal Information</h1>
      
                <div className={styles.rightDesc}>
                  <div className={styles.rightItems}>
                    <p>Salutation *</p>
      
                    <div className={styles.radionCon}>
                      <input type="radio" /> Mr
                      <input type="radio" /> Ms
                      <input type="radio" /> Dr
                      <input type="radio" /> Prof
                      <input type="radio" /> Other
                    </div>
                  </div>
      
                  <div className={styles.rightItems}>
                    <p>Name *</p>
                    <div className={styles.radionCon}>
                      <input
                        className={styles.name}
                        type="text"
                        placeholder="FirstName"
                      />
                      <input
                        className={styles.name}
                        type="text"
                        placeholder="Middle Name"
                      />
                      <input
                        className={styles.name}
                        type="text"
                        placeholder="Last Name"
                      />
                    </div>
                  </div>
      
                  <div className={styles.rightItems}>
                    <p>Gender *</p>
                    <div className={styles.radionCon}>
                      <input type="radio" /> Male
                      <input type="radio" /> Female
                      <input type="radio" /> Prefer not to disclose
                    </div>
                  </div>
      
                  <div className={styles.rightItems}>
                    <p>Date of Birth *</p>
                    <div className={styles.radionCon}>
                      <input type="date" />
                    </div>
                  </div>
      
                  <div className={styles.rightItems}>
                    <p>Position *</p>
                    <div className={styles.radionCon}>
                      <input type="radio" /> Student
                      <input type="radio" /> Faculty
                      <p className={styles.question}>?</p>
                      <span className={styles.alert}>
                        Select student if you are an alumni
                      </span>
                    </div>
                  </div>
                </div>
      
                {/* buttons */}
                <div className={styles.buttons}>
                  <button className={styles.btn} onClick={()=>{submithandler()}}>Next</button>
                </div>
              </div>
            </div>
          </div>)
    }
    return (
        <React.Fragment>
           {personalInfoForm()}
        </React.Fragment>
    );
}
export default PersonalInfo;